var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("DimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          type: this.item.type
        },
        on: {
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      [
        _vm.$v.item.variations.brand.$error
          ? _c("div", { staticClass: "red--text" }, [
              _vm._v("Please select Brand")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-autocomplete", {
          attrs: {
            items: _vm.brands,
            "item-value": "_id",
            label: "Brand",
            filter: _vm.filterBrandAndRange
          },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function(data) {
                return [
                  _vm._v("\n        " + _vm._s(data.item.name) + "\n      ")
                ]
              }
            },
            {
              key: "item",
              fn: function(data) {
                return [
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", {
                        domProps: { innerHTML: _vm._s("" + data.item.name) }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.selectedBrand,
            callback: function($$v) {
              _vm.selectedBrand = $$v
            },
            expression: "selectedBrand"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "v-card__actions" },
          [
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { small: "", flat: "", color: "primary" },
                on: {
                  click: function($event) {
                    return _vm.onClickingAddBrand()
                  }
                }
              },
              [_vm._v("Add Brand")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$v.item.variations.range.$error
          ? _c("div", { staticClass: "red--text" }, [
              _vm._v("Please select Range")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-autocomplete", {
          attrs: {
            items: _vm.ranges,
            "item-value": "_id",
            label: "Range",
            filter: _vm.filterBrandAndRange
          },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function(data) {
                return [
                  _vm._v("\n        " + _vm._s(data.item.name) + "\n      ")
                ]
              }
            },
            {
              key: "item",
              fn: function(data) {
                return [
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", {
                        domProps: { innerHTML: _vm._s("" + data.item.name) }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.item.variations.range,
            callback: function($$v) {
              _vm.$set(_vm.item.variations, "range", $$v)
            },
            expression: "item.variations.range"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "v-card__actions" },
          [
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { small: "", flat: "", color: "primary" },
                on: {
                  click: function($event) {
                    return _vm.onClickingAddRange()
                  }
                }
              },
              [_vm._v("Add Range")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$v.item.variations.fabricPricePerMeter.$error
          ? _c("div", { staticClass: "red--text" }, [
              _vm._v("Please enter Fabric Price Per Meter")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-text-field", {
          staticClass: "disableField",
          attrs: { label: "Fabric Price Per Meter", disabled: true },
          on: {
            change: function($event) {
              return _vm.getFabricSize()
            }
          },
          model: {
            value: _vm.item.variations.fabricPricePerMeter,
            callback: function($$v) {
              _vm.$set(_vm.item.variations, "fabricPricePerMeter", $$v)
            },
            expression: "item.variations.fabricPricePerMeter"
          }
        }),
        _vm._v(" "),
        _vm.$v.item.variations.fabricRollWidth.$error
          ? _c("div", { staticClass: "red--text" }, [
              _vm._v("Please enter Fabric Roll Width")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-text-field", {
          staticClass: "disableField",
          attrs: { label: "Fabric Roll Width", disabled: true },
          on: {
            change: function($event) {
              return _vm.getFabricSize()
            }
          },
          model: {
            value: _vm.item.variations.fabricRollWidth,
            callback: function($$v) {
              _vm.$set(_vm.item.variations, "fabricRollWidth", $$v)
            },
            expression: "item.variations.fabricRollWidth"
          }
        }),
        _vm._v(" "),
        _vm.$v.item.variations.fabricColorLabel.$error
          ? _c("div", { staticClass: "red--text" }, [
              _vm._v("Please enter Fabric - Colour Label")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-text-field", {
          attrs: { label: "Fabric - Colour Label" },
          model: {
            value: _vm.item.variations.fabricColorLabel,
            callback: function($$v) {
              _vm.$set(_vm.item.variations, "fabricColorLabel", $$v)
            },
            expression: "item.variations.fabricColorLabel"
          }
        })
      ],
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Control Side",
          value: _vm.item.variations.controlSide,
          options: ["Left", "Right"],
          v: _vm.$v.item.variations.controlSide,
          error: _vm.$v.item.variations.controlSide.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.controlSide = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Drive Type",
          value: _vm.item.variations.driveType,
          options: ["Cord and Cleat", "Chain Drive"],
          v: _vm.$v.item.variations.driveType,
          error: _vm.$v.item.variations.driveType.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.driveType = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.item.variations.driveType == "Cord and Cleat"
        ? _c(
            "div",
            [
              _c("CustomizationSelector", {
                attrs: {
                  title: "Cleat Type",
                  value: _vm.item.variations.cordCleatType,
                  options: ["Clear", "Chrome", "Brass"],
                  v: _vm.$v.item.variations.cordCleatType,
                  error: _vm.$v.item.variations.cordCleatType.$error
                },
                on: {
                  "selected-option": function($event) {
                    _vm.item.variations.cordCleatType = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.incInstall
        ? _c(
            "div",
            [
              _c("v-checkbox", {
                attrs: { label: "Install?", color: "primary" },
                model: {
                  value: _vm.customInstall,
                  callback: function($$v) {
                    _vm.customInstall = $$v
                  },
                  expression: "customInstall"
                }
              }),
              _vm._v(" "),
              _vm.customInstall
                ? _c("v-text-field", {
                    attrs: { label: "Install Price" },
                    model: {
                      value: _vm.item.installPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "installPrice", $$v)
                      },
                      expression: "item.installPrice"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$v.item.variations.margin.$error
        ? _c("div", { staticClass: "red--text" }, [
            _vm._v("Please enter Margin")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Margin", "append-icon": "%" },
        model: {
          value: _vm.item.variations.margin,
          callback: function($$v) {
            _vm.$set(_vm.item.variations, "margin", $$v)
          },
          expression: "item.variations.margin"
        }
      }),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4 ml-2" }, [
        _c("p", [
          _c("b", [_vm._v("Fabric Price:")]),
          _vm._v(" " + _vm._s(_vm.fabricPrice))
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Make Price:")]),
          _vm._v(" " + _vm._s(_vm.makePrice))
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Chain Drive Price:")]),
          _vm._v(" " + _vm._s(_vm.chainDrivePrice))
        ]),
        _vm._v(" "),
        _c("p", [_c("b", [_vm._v("GST:")]), _vm._v(" 10% ")])
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.addBrandDialoug,
            callback: function($$v) {
              _vm.addBrandDialoug = $$v
            },
            expression: "addBrandDialoug"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add New Brand")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.$v.brandNameText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Brand")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Brand" },
                    model: {
                      value: _vm.brandNameText,
                      callback: function($$v) {
                        _vm.brandNameText = $$v
                      },
                      expression: "brandNameText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.addBrandDialoug = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.onClickingSavedBrand()
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.addRangeDialoug,
            callback: function($$v) {
              _vm.addRangeDialoug = $$v
            },
            expression: "addRangeDialoug"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add New Range")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.$v.selectedBrandFromRangePopup.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Select Brand")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.brands,
                      "item-value": "_id",
                      label: "Select Brand",
                      filter: _vm.filterBrandAndRange
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.item.name) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function(data) {
                          return [
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", {
                                  domProps: {
                                    innerHTML: _vm._s("" + data.item.name)
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedBrandFromRangePopup,
                      callback: function($$v) {
                        _vm.selectedBrandFromRangePopup = $$v
                      },
                      expression: "selectedBrandFromRangePopup"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.rangeNameText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Range")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Range" },
                    model: {
                      value: _vm.rangeNameText,
                      callback: function($$v) {
                        _vm.rangeNameText = $$v
                      },
                      expression: "rangeNameText"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.priceText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Price")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Price" },
                    model: {
                      value: _vm.priceText,
                      callback: function($$v) {
                        _vm.priceText = $$v
                      },
                      expression: "priceText"
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.widthText.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Enter Width")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Add Width" },
                    model: {
                      value: _vm.widthText,
                      callback: function($$v) {
                        _vm.widthText = $$v
                      },
                      expression: "widthText"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Sheer")]),
                  _vm._v(" "),
                  _vm.$v.sheerOption.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please Select Sheer Option")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      attrs: { row: "" },
                      model: {
                        value: _vm.sheerOption,
                        callback: function($$v) {
                          _vm.sheerOption = $$v
                        },
                        expression: "sheerOption"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Yes", color: "primary", value: "true" }
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: { label: "No", color: "primary", value: "false" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.addRangeDialoug = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.onClickingSavedRange()
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f983ca26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f983ca26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/SoftRomanBlind.vue
// module id = null
// module chunks = 